import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Header from './components/Layout/Header';
import WhatsNewBanner from './components/Layout/WhatsNewBanner';
import Footer from './components/Layout/Footer';
import HomePage from './pages/HomePage';
import AdminPage from './pages/AdminPage';
import AdminLoginPage from './pages/AdminLoginPage';
import SsoCallbackPage from './pages/SsoCallbackPage';
import ChatEmbedPage from './pages/ChatEmbedPage';
import ChatWidget from './components/Chat/ChatWidget';

export default function App() {
  const { isAdmin, canSeeDashboard } = useAuth();
  const location = useLocation();

  // /chat-embed is loaded inside an iframe on external DH sites — it has NO
  // header/footer/banner and NO floating chat button (the host page provides
  // those).  Everything outside that route renders exactly as before.
  const isEmbed = location.pathname.startsWith('/chat-embed');

  const handleAdminClick = () => {
    window.location.href = '/admin';
  };

  if (isEmbed) {
    return (
      <Routes>
        <Route path="/chat-embed" element={<ChatEmbedPage />} />
      </Routes>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: 'var(--bg)' }}>
      <Header onAdminClick={handleAdminClick} isAdmin={isAdmin} />
      <WhatsNewBanner />

      <main style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* Hidden admin login — only accessible by direct URL, NOT linked anywhere */}
          <Route path="/dash-control" element={<AdminLoginPage />} />
          {/* Entra ID redirect-flow callback — finishes the SSO handshake */}
          <Route path="/auth/callback" element={<SsoCallbackPage />} />
          <Route
            path="/admin"
            element={canSeeDashboard ? <AdminPage /> : <Navigate to="/" replace />}
          />
          {/* Everything else falls back to home (no 404 → no hint that /admin exists) */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      <Footer />

      {/* Floating chat widget — always visible (in-app), NOT shown on /chat-embed */}
      <ChatWidget />
    </div>
  );
}
